export enum SubscriptionContentTypesEnum {
	DATAFRAME = 'Dataframe',
	CHART = 'Chart',
	TABLE = 'Table',
	DASHBOARD = 'Dashboard',
	REPORT = 'Report',
	USER_GROUP = 'User Group',
	ROLE = 'Role',
}
